<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">财务管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">财务列表</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">
                 <a-select style="width: 120px" allowClear @change="typehandleChange" placeholder="激活状态" :showArrow="show">
                    <a-select-option v-for="(option,x) in typeoption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select>

                 <a-select style="width: 120px" allowClear @change="jshandleChange" placeholder="结算状态" :showArrow="show">
                    <a-select-option v-for="(option,x) in jsoption" :key="x" :value="option.id">
                        {{option.name}}
                    </a-select-option>
                </a-select>

                <a-button :disabled="disabled" @click="toend" type="primary">结算</a-button>

            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search style="width:280px"
                    placeholder="关键字（客服名称/订单号）"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ onChange: onSelectChange}" rowKey="cmid" :scroll="{x: 1100}" :pagination="pageshow" :columns="columns" :data-source="data">
                    <router-link slot="name" slot-scope="text,record" :to="{path:'customdetail',query: {id:record.id}}" >
                        {{ text }}
                    </router-link>

                    <span slot="type" slot-scope="text">
                        <a-tag v-if="text==1" color="orange">已签收</a-tag>
                        <a-tag v-if="text==2" color="green">已激活</a-tag>
                    </span>

                     <span slot="state" slot-scope="text">
                        <a-tag v-if="text==0" color="orange">未结算</a-tag>
                        <a-tag v-if="text==1" color="green">已结算</a-tag>
                    </span>

                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>

                    <a style="color:#1890ff;display:flex;align-items: center;" slot="phone" slot-scope="text,record" @click="totel(record.id)">
                        <a-icon type="phone" theme="filled"/> <span style="margin-left:3px">{{text}}</span>
                    </a>
                    
                    <!-- <span slot="action" slot-scope="text,record">
                        <router-link :to="{path:'customdetail',query: {id:record.id}}"><a-icon type="copy"/> 详情</router-link>
                    </span> -->
                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

    </div>
    
</template>

<script>
 import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
 import {formatDate} from '../../utils/formate.js'
const columns = [
    {title: 'ID',dataIndex: 'cmid',key: 'cmid',fixed: 'left',width:100},
    {title: '订单号',dataIndex: 'orderno',key: 'orderno',width:170},
    {title: '用户姓名',dataIndex: 'username_user',key: 'username_user'},
    {title: '激活号码',dataIndex: 'telephone',key: 'telephone'},
    {title: '状态',dataIndex: 'type',key: 'type',scopedSlots: { customRender: 'type' }},
    {title: '客服姓名',dataIndex: 'username_kf',key: 'username_kf'},

    {title: '提成',dataIndex: 'money',key: 'money'},
    {title: '结算状态',dataIndex: 'state',key: 'state',scopedSlots: { customRender: 'state' }},
    {title: '日期',dataIndex: 'addtime',key: 'addtime',scopedSlots: { customRender: 'date' }}
];

export default {
    filters: {
      //年-月-日
      formatDate (time) {
        time = time * 1000
        let date = new Date(time)
        return formatDate (date, 'yyyy-MM-dd')
      }
    },
    data(){
        return{
            locale,
            show:true,
            lyoption:["来源1","来源2"],
            typeoption:["标签1","标签2"],
            searchtext:"",
            tstext:"",
            tablespinning:true,
            tabley:"",
            tablex:"",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            columns,
            data:[],
            pagination:{
                total:20
            },
            totalpage:2,
            pageshow:false,
            currentpagination:"",
            pageSizeOptions:['10','20','30','40','100','200'],
            size:10,
            editvisible:false,
            numshow:true,
            // gjvisible:false,
            form: this.$form.createForm(this, { name: 'coordinated' }),

            typeoption:[{name:'全部',id:""},{name:'已签收',id:"1"},{name:'已激活',id:"2"}],
            type:"",
            jsoption:[{name:'全部',id:""},{name:'已结算',id:"1"},{name:'未结算',id:"0"}],
            state:"",

            disabled:true,
            endids:[]
        }
    },
    watch: {
      windowHeight (val) {
        this.tablex=val-300
      },
    },
    mounted(){
        this.fetch()

         window.fullWidth = document.documentElement.clientWidth;
        this.windowWidth = window.fullWidth;  
        this.tablex=this.windowWidth-300
        window.onresize = () => {
            return (() => {
                window.fullWidth = document.documentElement.clientWidth;
                this.windowWidth = window.fullWidth;  // 高
                this.tablex=this.windowWidth-300
            })()
        };
    },
    methods:{

        // 结算状态
        onSelectChange(selectedRowKeys){
            // console.log(selectedRowKeys.length)
            if(selectedRowKeys.length>0){
                this.disabled=false
            }else{
                this.disabled=true
            }
            this.endids=selectedRowKeys
        },
        toend(){
            this.fetch()
            this.disabled=true
        },


        onSearch(){
            this.fetch()
        },

        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 外呼
        totel(id){

        },
        ondateChange(date, dateString) {
            console.log(date, dateString);
        },

        // 标签筛选
        typehandleChange(value){
            this.type=value
            this.fetch()
        },
        jshandleChange(value){
            this.state=value
            this.fetch()
        },
        // 数据
        fetch(){
            this.$axios.post('/api/order/commissionlist',{
                pagesize: this.size,
                page:this.currentpage,
                search:this.searchtext,
                type:this.type,
                state:this.state
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{

                }
               
            })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/finance/financelist.vue